import PropTypes from 'prop-types';

export const SsoUserType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  verifiedAt: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string
});

export const UserType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phoneNumber: PropTypes.string,
  otherInfo: PropTypes.shape({
    homeless: PropTypes.string.isRequired,
    householdTotal: PropTypes.number,
    streetAddress: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    cellPhone: PropTypes.string,
    workPhone: PropTypes.string,
    homePhone: PropTypes.string,
    birthDate: PropTypes.string,
    gender: PropTypes.string
  }),
  loginUser: SsoUserType.isRequired,
  linkedGuest: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    streetAddress: PropTypes.string,
    apartment: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    county: PropTypes.string,
    homeless: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    homePhone: PropTypes.string,
    workPhone: PropTypes.string,
    cellPhone: PropTypes.string
  }),
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
  deletedAt: PropTypes.string
});
